import React, {useState} from "react";
import CodeFormField from "./CodeFormField";

const AddCodeForm = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Codes", url: "/codes"},
        {content: "Add Code", url: ""}
    ])
    return (
        <>
            <CodeFormField crumbs={crumbs} title={"Add Code"} btnText={"Create"}/>
        </>
    )

}

export default AddCodeForm;